/*
 *   File : amount-input.js
 *   Author : https://evoqins.com
 *   Description : Amount input component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { memo, useEffect, useRef, useState } from "react";

//styles
import styles from "../../Style/Component/input.module.scss";

const CustomAmountInput = (props) => {

    const inputRef = useRef(null);
    const [value, setValue] = useState(props.value);
    const [isInputFocused, setIsInputFocused] = useState(false);
    const [floatingLabel, setFloatingLabel] = useState(false);

    useEffect(() => {
        setValue(props.value);

        if (props.value) {
            setFloatingLabel(true);
        }

    }, [props.value]);

    const _handleChange = (event) => {
        const input_value = event.target.value;

        // Removing space and comma
        const formatted_value = Number(input_value.replaceAll(",", ''));

        const maxValue = props.maxValue || 999999999;


        if (isNaN(formatted_value) === false) {
            if (props.type == 2 && (formatted_value <= maxValue)) {
                setValue(formatted_value);
                props.handleChange(formatted_value);
            } else {
                if ((formatted_value <= maxValue)) {
                    setValue(formatted_value);
                    props.handleChange(formatted_value);
                };
            };

        } else {
            setValue('');
            props.handleChange('');
        }
    };


    const _preventDefaults = (e) => {
        const key_code = e.keyCode || e.which;
        const is_ctrl_pressed = e.ctrlKey || e.metaKey; // Check if Ctrl key is pressed


        if (key_code == 9 || // Tab key
            (is_ctrl_pressed && (key_code == 65 || key_code == 67 || key_code == 88 || key_code == 86))
        ) {
            // Ctrl+A, Ctrl+C, Ctrl+X, or Ctrl+V    
            e.preventDefault();
        }

        if (
            (key_code >= 48 && key_code <= 57) || // 0-9
            (key_code >= 96 && key_code <= 105) || // Numpad 0-9
            key_code === 8 || // Backspace
            (key_code >= 37 && key_code <= 40) // Arrow keys
        ) {
            // Allow the keypress
        } else {
            e.preventDefault();
        }
    };

    const _handleFocus = () => {
        if (isInputFocused === false) {
            setIsInputFocused(true);
            setFloatingLabel(true);
            inputRef.current.focus();
        };
    };

    const _handleBlur = () => {
        setIsInputFocused(false);
        if (value === "") {
            setFloatingLabel(false);
        }
    };


    return (
        <div className={`${props.className} ${styles.e_amount_input_wrapper}`}>

            {
                props.label && props.floatingLabel === false &&
                <label className={`${props.labelStyle} e-text-dark-charcoal e-font-weight-400 e-alt-font-poppins line-height-24px e-font-14 mb-2`}>
                    {props.label}
                    {props.require && <span className='e-text-sunset-orange'>*</span>}
                </label>
            }

            <div className={`${isInputFocused ? "e-border-1px-egyptian-blue" : "e-border-1px-sonic-silver"} ${props.errorMsg && 'border-red-1px '}  ${props.inputClassName} d-flex cursor-text  padding-12px-lr  e-border-radius-10 position-relative   `}>
                {
                    props.floatingLabel &&
                    <label className={`${props.labelStyle} ${floatingLabel ? "focused pe-none" : ""} floating-label e-text-dark-charcoal e-font-weight-400 e-alt-font-poppins line-height-24px e-font-14`} onClick={_handleFocus}>
                        {props.label}
                        {props.require && <span className='e-text-sunset-orange'>*</span>}
                    </label>
                }

                {
                    <p className={`${props.floatingLabel ? "py-3" : "padding-12px-tb-res padding-12px-tb"} e-font-14-res   mb-0 e-text-charleston-green e-font-16 e-primary-font-inter e-font-weight-500  line-height-22px`}>
                        ₹
                    </p>
                }
                <input required
                    value={value && value.toLocaleString('en-IN')}
                    ref={props.ref || inputRef}
                    // value={props.value && props.value.toLocaleString('en-IN')}
                    id={props.label}
                    type="text"
                    className={` ${props.floatingLabel ? "e-font-14-res e-font-16 padding-16px-tb" : "no-floating-label padding-12px-tb"} padding-12px-tb-res   border-0 e-bg-transparent w-100 no-outline e-text-charleston-green  e-primary-font-inter e-font-weight-500 line-height-22px`}
                    placeholder={isInputFocused || props.floatingLabel == false ? props.placeholder : ""}
                    disabled={props.isDisabled}
                    autoComplete="off"
                    onChange={_handleChange}
                    onFocus={_handleFocus}
                    onBlur={_handleBlur}
                    onKeyDown={_preventDefaults}
                />

                {/* Error text */}
                {
                    props.errorMsg !== "" &&
                    <p className={`${props.errorMsg === "" ? "opacity-0 z-index-neg-1" : "opacity-100"} mb-0 e-error-message e-font-12 line-height-12px position-absolute  top-100 start-0 padding-2-top`}>
                        {props.errorMsg}
                    </p>
                }
            </div>
        </div>
    );
};

export default memo(CustomAmountInput);

CustomAmountInput.defaultProps = {
    floatingLabel: false
}